import amplitude from 'amplitude-js';

export const initAmplitude = () => {
  amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE || '');
};

export const setAmplitudeUserId = (userId: string) => {
  amplitude.getInstance().setUserId(userId);
};

export const setAmplitudeUserProperties = (properties: any) => {
  amplitude.getInstance().setUserProperties({
    ...properties,
    // @ts-ignore
    Browser: `${navigator.appCodeName} ${navigator.appVersion}`,
    'Web Version': process.env.REACT_APP_VERSION,
  });
};

export const sendAmplitudeData = (eventType: string, eventProperties: any) => {
  amplitude.getInstance().logEvent(eventType, eventProperties);
};

